import { render, staticRenderFns } from "./VideoLayout.vue?vue&type=template&id=55b6adf3&scoped=true&"
import script from "./VideoLayout.vue?vue&type=script&lang=js&"
export * from "./VideoLayout.vue?vue&type=script&lang=js&"
import style0 from "./VideoLayout.vue?vue&type=style&index=0&id=55b6adf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b6adf3",
  null
  
)

export default component.exports